<template>
    <div class="type-area">
        <div style="margin: 0 10px;" class="hidden-sm-and-down">
            <el-row :gutter="20">

                <el-carousel
                        indicator-position="outside"
                        height="210px"
                        :interval="5000"
                        arrow="never"
                >
                    <el-carousel-item
                            v-for="(item2, index2) in hxContentArr"
                            :key="index2"
                    >
                        <el-col
                                :xs="24"
                                :sm="8"
                                :md="8"
                                :lg="8"
                                :xl="8"
                                v-for="(item3, index3) in item2"
                                :key="index3"
                        >
                            <el-card style="height: 200px;">
                                <div style="display: flex; align-items: center">
                                    <el-image
                                            style="width: 80px; height: 80px; border-radius: 50%"
                                            :src="item3.url"
                                    ></el-image>
                                    <div style="margin-left: 20px">
                                        <div
                                                v-if="item3.title"
                                                style="font-weight: bold; font-size: 20px"
                                        >
                                            {{ item3.title }}
                                        </div>
                                        <div v-if="item3.subtitle" style="color: #0094ff;margin-top: 10px;">
                                            {{ item3.subtitle }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                        class="ql-editor content"
                                        v-if="item3.content"
                                ><p v-html="item3.content"></p></div>
                            </el-card>
                        </el-col>
                    </el-carousel-item>
                </el-carousel>
            </el-row>
        </div>
        <div style="margin: 0 10px;" class="hidden-sm-and-up">
            <el-row :gutter="20">
                <el-carousel
                        indicator-position="outside"
                        height="200px"
                        :interval="5000"
                >
                    <el-carousel-item
                            v-for="(item, index) in hxContentList"
                            :key="index"
                    >
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="padding: 0 20px !important;">
                            <el-card>
                                <div style="display: flex; align-items: center">
                                    <el-image
                                            style="width: 80px; height: 80px; border-radius: 50%"
                                            :src="item.url"
                                    ></el-image>
                                    <div style="margin-left: 20px">
                                        <div style="font-weight: bold; font-size: 20px">
                                            {{ item.title }}
                                        </div>
                                        <div style="color: #0094ff">{{ item.subtitle }}</div>
                                    </div>
                                </div>
                                <div
                                        class="ql-editor"
                                        v-html="item.content"
                                        style="
                          color: #66646d;
                          padding: 13px 21px 2px 21px;
                          font-size: 12px;
                          line-height: 24px;
                          text-indent: 2em;
                          margin-top:5px
                        "
                                ></div>
                            </el-card>
                        </el-col>
                    </el-carousel-item>
                </el-carousel>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "multi-rotation-index",
        props:{
            hxContentList:Array,
            hxContentArr:Array,
        }
    }
</script>


<style lang="scss" scoped>

    .content{
        color: #66646d;
        padding: 13px 21px 2px 21px;
        font-size: 12px;
        line-height: 24px;
        text-indent: 2em;
    }

    .type-area{
        width: 100%;
        margin: 10px auto;
    }

    @media screen and (min-width: 1400px) {

    }

    @media screen and (min-width: 1200px) {

    }

    @media screen and (max-width: 1200px) {

    }

    @media screen and (max-width: 870px) {

    }

    @media screen and (max-width: 570px) {
        .type-area{
            width: 100%;
            margin: 0 auto;
        }

    }
</style>
